import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const steps = [
  {
    number: '01',
    title: 'Case Intake',
    description:
      'Enter settlement details once — client info, gross settlement, attorney fee, and every lien holder.',
  },
  {
    number: '02',
    title: 'Automated Outreach & Follow-Up',
    description:
      "AI-assisted reduction letters send from your firm's own address, with automatic follow-up until a provider responds.",
  },
  {
    number: '03',
    title: 'Negotiation Tracking',
    description:
      'Every response — accepted, rejected, or countered — updates the case instantly, no spreadsheet required.',
  },
  {
    number: '04',
    title: 'Disbursement',
    description:
      'Once every lien is resolved, generate a client-ready disbursement sheet — print-perfect, in one click.',
  },
];

const Works = () => {
  return (
    <section className="works" id="how-it-works" aria-labelledby="works-heading">
      <Container>
        <Row className="justify-content-center text-center">
          <Col xs={12} lg={8}>
            <p className="works__eyebrow">How It Works</p>
            <h2 id="works-heading" className="works__title">
              From intake to disbursement, on one rail.
            </h2>
          </Col>
        </Row>

        <Row as="ol" className="works__steps list-unstyled g-4 g-xl-0 mb-0">
          {steps.map((step, index) => (
            <Col
              as="li"
              key={step.number}
              xs={12}
              sm={6}
              xl={3}
              className={`works__step${index < steps.length - 1 ? ' works__step--divider' : ''}`}
            >
              <span className="works__number">{step.number}</span>
              <h3 className="works__step-title">{step.title}</h3>
              <p className="works__step-text mb-0">{step.description}</p>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Works;
